import { validateFieldSet } from '../shared/validateFieldSet';

export function validateUpdateCompanyData(
  paymentAddressLine1?: string,
  paymentCity?: string,
  paymentState?: string,
  paymentZipCode?: string,
  bankName?: string,
  bankRoutingNumber?: string,
  accountName?: string,
  accountNumber?: string,
  bankAddressLine1?: string,
  bankCity?: string,
  bankState?: string,
  bankZipCode?: string,
): boolean {
  const paymentAddressIsValid = validateFieldSet([paymentAddressLine1, paymentCity, paymentState, paymentZipCode]);
  const wireSettingIsValid = validateFieldSet([
    bankName,
    bankRoutingNumber,
    accountName,
    accountNumber,
    bankAddressLine1,
    bankCity,
    bankState,
    bankZipCode,
  ]);
  return paymentAddressIsValid && wireSettingIsValid;
}

export function validateDomains(domains: string): boolean {
  if (domains === '') return true;
  const domainRegex = /^[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,63}$/i;
  const domainsArray = domains.split(',');

  return domainsArray.every((domain) => domainRegex.test(domain.trim()));
}

export function validateEmailData(domain: string, emailFrom: string): boolean {
  if (emailFrom.length > 0 && domain.length === 0) {
    return false;
  }
  if (emailFrom.length === 0 && domain.length === 0) {
    return true;
  }
  const parsedDomain = emailFrom.split('@')[1]?.replace(/>/, '');
  return parsedDomain === domain;
}

export function validatePortalDomain(portalDomain: string): boolean {
  if (!portalDomain) {
    return false;
  }
  try {
    const url = new URL(`https://${portalDomain}`);
    // allow only the default path
    if (url.pathname !== '/' && url.pathname !== '') {
      return false;
    }
  } catch (_error: unknown) {
    // invalid url
    return false;
  }
  return true;
}
